import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { clearToken } from '../store/slices/authSlice';

const Bar = styled.nav`
  width: 100%;
  height: 60px;
  background: #111827;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;
`;

const Left = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  font-weight: 700;
`;

const Brand = styled.span`
  font-size: 18px;
`;

const NavLinks = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const NavLink = styled(Link)`
  color: ${props => (props.$active ? '#60a5fa' : '#e5e7eb')};
  text-decoration: none;
  font-size: 14px;
  padding: 8px 10px;
  border-radius: 6px;
  &:hover {
    background: #1f2937;
    color: #fff;
  }
`;

const Right = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const Button = styled.button`
  background: #dc2626;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 8px 12px;
  cursor: pointer;
  font-size: 14px;
  &:hover {
    background: #b91c1c;
  }
`;

function NavBar() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated);

  const handleLogout = () => {
    dispatch(clearToken());
    navigate('/login');
  };

  return (
    <Bar>
      <Left>
        <Brand>디보 관리자</Brand>
        <NavLinks>
          <NavLink to="/dashboard" $active={location.pathname === '/dashboard'}>대시보드</NavLink>
          <NavLink to="/admin" $active={location.pathname === '/admin'}>회원관리</NavLink>
          <NavLink to="/extension-post" $active={location.pathname === '/extension-post'}>익스텐션추가</NavLink>
          <NavLink to="/extension-list" $active={location.pathname === '/extension-list'}>익스텐션리스트</NavLink>
          <NavLink to="/site-list" $active={location.pathname === '/site-list'}>사이트</NavLink>
        </NavLinks>
      </Left>
      <Right>
        {isAuthenticated && <Button onClick={handleLogout}>로그아웃</Button>}
      </Right>
    </Bar>
  );
}

export default NavBar;


